<template>
  <div>
    <b-form-group>
      <div class="my-2 p-2">
        <b-form-radio
          v-model="deliveryType"
          name="delivery-type"
          value="home"
          @input="onDeliveryInput"
        >
          <div class="label">
            {{ $t("shopping_cart_delivery.home_delivery") }}
          </div>
          <div>
            {{ $t("shopping_cart_delivery.select_address") }}
          </div>
          <b-card class="border mt-3">
            <AddressListLite
              :value="deliveryAddressUuid"
              @input="onAddressChange"
              v-on:address-click="onAddressClick"
              :filter_address_by_current_country="
                filter_address_by_current_country
              "
            />
          </b-card>
        </b-form-radio>
      </div>
    </b-form-group>
  </div>
</template>

<script>
import AddressListLite from "@/components/AddressListLite";

export default {
  name: "shopping-cart-delivery",
  components: {
    AddressListLite,
  },
  props: {
    deliveryAddressUuid: {
      type: String,
      default: undefined,
    },
    filter_address_by_current_country: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      deliveryType: "home",
      addressUuid: undefined,
    };
  },
  methods: {
    onDeliveryInput(deliveryType) {
      this.deliveryType = deliveryType;
      this.emitDelivery();
    },
    onAddressClick() {
      this.$emit("address-click");
    },
    onAddressChange(addressUuid) {
      this.addressUuid = addressUuid;
      this.emitDelivery();
    },
    emitDelivery() {
      var delivery = {
        type: this.deliveryType,
        addressUuid:
          this.deliveryType === "home" ? this.addressUuid : undefined,
      };
      this.$emit("input", delivery);
    },
  },
  fallbackI18n: {
    messages: {
      und: {
        shopping_cart_delivery: {
          home_delivery: "Home delivery",
          select_address:
            "Select your address for the delivery of the products",
        },
      },
    },
  },
};
</script>

<style scoped lang="scss"></style>
